// extracted by mini-css-extract-plugin
module.exports = {"root":"_1WE3z","input":"_1z5kl","footer":"_2cgbj","submit":"_1qMZ0","preloader":"_1KUm7","disabled":"_3Dlfz","pending":"_2eA8t"};